import { takeEvery } from 'redux-saga/effects';
import { rateVideoRequestEffect } from './effects/rate-video-request';
import { RATE_VIDEO_REQUEST } from './actions';

export const rateVideoSaga = function* () {
  yield takeEvery(RATE_VIDEO_REQUEST, rateVideoRequestEffect);
};
